var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandling(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 8.66762C13.3327 12.001 10.9993 13.6676 8.22602 14.6343C8.08079 14.6835 7.92304 14.6811 7.77935 14.6276C4.99935 13.6676 2.66602 12.001 2.66602 8.66762V4.00095C2.66602 3.82414 2.73625 3.65457 2.86128 3.52955C2.9863 3.40452 3.15587 3.33428 3.33268 3.33428C4.66602 3.33428 6.33268 2.53428 7.49268 1.52095C7.63392 1.40028 7.81358 1.33398 7.99935 1.33398C8.18511 1.33398 8.36478 1.40028 8.50602 1.52095C9.67268 2.54095 11.3327 3.33428 12.666 3.33428C12.8428 3.33428 13.0124 3.40452 13.1374 3.52955C13.2624 3.65457 13.3327 3.82414 13.3327 4.00095V8.66762Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandling);
export default __webpack_public_path__ + "static/media/handling.9d1affb4c1853542eff516955ae0191e.svg";
export { ForwardRef as ReactComponent };